
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useOrganizationManagement } from '@/hooks/useOrganizationManagement';
import { OrganizationForm } from '@/components/shared/OrganizationForm';
import { OrganizationCard } from './OrganizationCard';
import { OrganizationEmptyState } from './OrganizationEmptyState';

export const OrganizationManagement = () => {
  const {
    organizations,
    isLoading,
    isCreateDialogOpen,
    setIsCreateDialogOpen,
    editingOrg,
    setEditingOrg,
    hoveredOrgId,
    setHoveredOrgId,
    formData,
    setFormData,
    resetForm,
    handleSubmit,
    handleEdit,
    handleDelete,
    handleManageMembers,
    isCreating,
    isUpdating,
    isDeleting,
  } = useOrganizationManagement();

  if (isLoading) {
    return <div>Loading organizations...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Organizations</h3>
        <Button onClick={() => setIsCreateDialogOpen(true)} disabled={isDeleting}>
          <Plus className="h-4 w-4 mr-2" />
          Create Organization
        </Button>
      </div>

      <OrganizationForm
        isOpen={isCreateDialogOpen || !!editingOrg}
        onOpenChange={(open) => {
          if (!open) {
            setIsCreateDialogOpen(false);
            setEditingOrg(null);
            resetForm();
          }
        }}
        editingOrg={editingOrg}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
        isLoading={isCreating || isUpdating}
      />

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {organizations?.map((org) => (
          <OrganizationCard
            key={org.id}
            organization={org}
            hoveredOrgId={hoveredOrgId}
            onMouseEnter={() => setHoveredOrgId(org.id)}
            onMouseLeave={() => setHoveredOrgId(null)}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onManageMembers={handleManageMembers}
          />
        ))}
      </div>
      
      {organizations?.length === 0 && <OrganizationEmptyState />}
    </div>
  );
};
